import influencerAPIs from '../components/views/Influencer/influencerAPIs'
import apiService from '../services/apiService'
import moment from 'moment';
import orderBy from 'lodash/orderBy';
import generalConfig from '@/config'
const infServiceBaseURL = generalConfig.apiServiceBaseURL.influencer // use of influencer service base url
const state = {
  influencers: [],
  igInf: {},
  tiktokInf: {},
  youtubeInf: {},
  xhsInf: {},
  fbInf: {},
  linkedinInf: {},
  twitterInf: {},
  infDetail: {},
  savedInfMerge: false,
  // rate card
  rateCards: [],
  savedRateCard: false,
  // creator community
  creatorCommunities: [],
  savedCreatorCommunity: false,
  savedPlatforms: false,
  savedPlatformsNotFoundErr: false,
  // imported creators
  importedCreators: [],
  importedCreatorGenres: [],
  importedCreatorCols: [],
  importedCreatorDtl: null,
  savedImportedCreator: null,
  // social data
  socialDataExist: false,
  socialDataSuccess: false,
  socialDataErrMsg: '',
  deletedAud: false,
  // tagging
  allTags: [],
  assignedTags: [],
  allAssignedTags: [],
  customTag: [],
  updatedTag: false
}

const actions = {
  /**
   * Update influencer
   */
  async update({ commit }, payload) {
    try {
      await influencerAPIs.editInfluencer(payload)
    } catch (err) {
      console.error(err)
      return ''
    }
  },
  /**
   * Get all rate card lists
   * @param {*} commit
   * @returns
  */
  async getRateCardLists ({ commit }, payload) {
    try {
      let params = ''
      if (payload) {
        const { filters } = payload
        params = Object.keys(filters)
        .map(key => `${key}=${filters[key]}`)
        .join('&')
      }
      let data = await influencerAPIs.getAllRateCards(params)
      data = data.map(i => {
        i.updatedAt = moment(i.updatedAt).format('YYYY-MM-DD HH:mm:ss')
        return i
      })
      data = orderBy(data, ['updatedAt'], ['desc'])
      commit('SET_RATE_CARD', data)
    } catch (err) {
      console.error(err)
      return ''
    }
  },
  /**
   * Delete Rate Card Data
   * @param {*} commit
   * @returns
  */
  async deleteRateCard ({ commit }, payload) {
    try {
      commit('SET_DATA', {
        name: 'savedRateCard',
        data: false
      })
      await apiService.post(infServiceBaseURL + '/rate-card/delete', payload)
      commit('SET_DATA', {
        name: 'savedRateCard',
        data: true
      })
    } catch (err) {
      console.error(err)
      return ''
    }
  },
  /**
   * Get all creator community lists
   * @param {*} commit
   * @returns
  */
  async getCreatorCommunityLists ({ commit }, payload) {
    try {
      let params = ''
      if (payload) {
        const { filters } = payload
        params = Object.keys(filters)
        .map(key => `${key}=${filters[key]}`)
        .join('&')
      }
      let data = await influencerAPIs.getAllCreatorCommunities(params)
      data = data.map(i => {
        i.updatedAt = moment(i.updatedAt).format('YYYY-MM-DD HH:mm:ss')
        return i
      })
      data = orderBy(data, ['updatedAt'], ['desc'])
      commit('SET_CREATOR_COMMUNITY', data)
    } catch (err) {
      console.error(err)
      return ''
    }
  },
  /**
   * Delete Creator Community Data
   * @param {*} commit
   * @returns
  */
  async deleteCreatorCommunity ({ commit }, payload) {
    try {
      commit('SET_DATA', {
        name: 'savedCreatorCommunity',
        data: false
      })
      await apiService.post(infServiceBaseURL + '/creator-community/delete', payload)
      commit('SET_DATA', {
        name: 'savedCreatorCommunity',
        data: true
      })
    } catch (err) {
      console.error(err)
      return ''
    }
  },
  /**
   * save rate card data
   * @param {*} commit
   * @returns
  */
  async saveRateCard ({ commit }, data) {
    try {
      commit('UNSET_SAVE_RATECARD')
      await influencerAPIs.saveRateCard(data)
      commit('SET_SAVE_RATECARD')
    } catch (err) {
      console.error(err)
      return ''
    }
  },
  /**
   * save creator community data
   * @param {*} commit
   * @returns
  */
  async saveCreatorCommunity ({ commit }, data) {
    try {
      commit('UNSET_SAVE_CREATORCOMMUNITY')
      await influencerAPIs.saveCreatorCommunity(data)
      commit('SET_SAVE_CREATORCOMMUNITY')
    } catch (err) {
      console.error(err)
      return ''
    }
  },
  async createMultiplePlatforms({ commit }, payload) {
    try {
      commit('UnsetSavedPlatforms')
      commit('SET_DATA', {
        name: 'savedPlatformsNotFoundErr',
        data: false
      })
      await influencerAPIs.saveMutliplePlatforms(payload.data)
      commit('SetSavedPlatforms')
    } catch (err) {
      console.error(err)
      if (err.response.status === 404) {
        commit('SET_DATA', {
          name: 'savedPlatformsNotFoundErr',
          data: true
        })
      }
      return ''
    }
  },
  async discountPlatforms({ commit }, payload) {
    try {
      commit('UnsetSavedPlatforms')
      await influencerAPIs.discountPlatforms(payload.data)
      commit('SetSavedPlatforms')
    } catch (err) {
      console.error(err)
      return ''
    }
  },
  /**
   * Delete Reject Platform
   * @param {*} commit
   * @returns
  */
  async rejectPlatform ({ commit }, payload) {
    try {
      commit('SET_DATA', {
        name: 'savedPlatforms',
        data: false
      })
      await apiService.post(infServiceBaseURL + '/reject/platform', payload)
      commit('SET_DATA', {
        name: 'savedPlatforms',
        data: true
      })
    } catch (err) {
      console.error(err)
      return ''
    }
  },
  /**
   * Import influencer audience data
   * @param {*} commit
   * @returns
  */
  async getAudienceData ({ commit }, payload) {
    try {
      commit('SET_SocialDataErrMsg', '')
      commit('SET_SocialDataSuccess', false)
      commit('SET_SocialDataExist', false)
      let filters = []
      if (payload) {
        filters = payload.filters
      }
      let resp = await influencerAPIs.importInfluencers(filters)
      // return fail fetching social data
      if (resp.failedInfluencers && resp.failedInfluencers.length) {
        commit('SET_SocialDataErrMsg', resp.failedInfluencers[0].error ? resp.failedInfluencers[0].error.error.message : 'Cannot fetch audience data')
        return
      }
      // check social data exists
      if (filters.handleItems && resp.influencers && resp.influencers.length) {
        if (resp.influencers.find(inf => inf.handle === filters.handleItems[0].handle && inf.exist)) {
          commit('SET_SocialDataExist', true)
          return
        }
      }
      // commit for new social data record
      commit('SET_SocialDataSuccess', true)
    } catch (err) {
      console.error(err)
      return ''
    }
  },
  /**
   * get inf by ig handle
   * @param {*} commit
   * @returns
  */
  async getInfluencerByIgHandle ({ commit }, payload) {
    try {
      let params = ''
      if (payload) {
        const { filters } = payload
        params = Object.keys(filters)
        .map(key => `${key}=${filters[key]}`)
        .join('&')
      }
      commit('SET_IgInf', {})
      commit('SET_CompareInfEmpty')
      let resp = await influencerAPIs.getInfluencerByIgHandle(params)
      if (resp) {
        commit('SET_IgInf', resp)
      }
    } catch (err) {
      console.error(err)
      return ''
    }
  },
  /**
   * get inf by tiktok handle
   * @param {*} commit
   * @returns
  */
  async getInfluencerByTikTokHandle ({ commit }, payload) {
    try {
      let params = ''
      if (payload) {
        const { filters } = payload
        params = Object.keys(filters)
        .map(key => `${key}=${filters[key]}`)
        .join('&')
      }
      commit('SET_TikTokInf', {})
      commit('SET_CompareInfEmpty')
      let resp = await influencerAPIs.getInfluencerByTikTokHandle(params)
      if (resp) {
        commit('SET_TikTokInf', resp)
      }
    } catch (err) {
      console.error(err)
      return ''
    }
  },

  /**
   * get inf by youtube handle
   * @param {*} commit
   * @returns
  */
  async getInfluencerByYoutubeHandle ({ commit }, payload) {
    try {
      let params = ''
      if (payload) {
        const { filters } = payload
        params = Object.keys(filters)
        .map(key => `${key}=${filters[key]}`)
        .join('&')
      }
      commit('SET_YoutubeInf', {})
      commit('SET_CompareInfEmpty')
      let resp = await influencerAPIs.getInfluencerByYoutubeHandle(params)
      if (resp) {
        commit('SET_YoutubeInf', resp)
      }
    } catch (err) {
      console.error(err)
      return ''
    }
  },
  /**
   * get inf by xhs handle
   * @param {*} commit
   * @returns
  */
  async getInfluencerByXHSHandle({ commit }, payload) {
    try {
      let params = ''
      if (payload) {
        const { filters } = payload
        params = Object.keys(filters)
        .map(key => `${key}=${filters[key]}`)
        .join('&')
      }
      commit('SET_DATA', {
        name: 'xhsInf',
        data: {}
      })
      commit('SET_CompareInfEmpty')
      let resp = await influencerAPIs.getInfluencerByXHSHandle(params)
      if (resp) {
        commit('SET_DATA', {
          name: 'xhsInf',
          data: resp
        })
      }
    } catch (err) {
      console.error(err)
      return ''
    }
  },
  /**
   * get inf by facebook handle
   * @param {*} commit
   * @returns
  */
  async getInfluencerByFbHandle({ commit }, payload) {
    try {
      let params = ''
      if (payload) {
        const { filters } = payload
        params = Object.keys(filters)
        .map(key => `${key}=${filters[key]}`)
        .join('&')
      }
      commit('SET_DATA', {
        name: 'fbInf',
        data: {}
      })
      commit('SET_CompareInfEmpty')
      let resp = await influencerAPIs.getInfluencerByFbHandle(params)
      if (resp) {
        commit('SET_DATA', {
          name: 'fbInf',
          data: resp
        })
      }
    } catch (err) {
      console.error(err)
      return ''
    }
  },
  /**
   * get influencer by LinkedIn handle
   * @param {*} commit
   * @returns
  */
  async getInfluencerByLinkedInHandle({ commit }, payload) {
    try {
      let params = ''
      if (payload) {
        const { filters } = payload
        params = Object.keys(filters)
        .map(key => `${key}=${encodeURIComponent(filters[key])}`)
        .join('&')
      }
      commit('SET_DATA', {
        name: 'linkedinInf',
        data: {}
      })
      commit('SET_CompareInfEmpty')
      let resp = await influencerAPIs.getInfluencerByLinkedInHandle(params)
      if (resp) {
        commit('SET_DATA', {
          name: 'linkedinInf',
          data: resp
        })
      }
    } catch (err) {
      console.error(err)
      return ''
    }
  },
  async getInfluencerByTwitterHandle({ commit }, payload) {
    try {
      const filters = payload ? payload.filters : {}
      const params = Object.keys(filters)
        .map(key => `${key}=${encodeURIComponent(filters[key])}`)
        .join('&')
      commit('SET_DATA', { name: 'twitterInf', data: {} })
      commit('SET_CompareInfEmpty')
      const resp = await influencerAPIs.getInfluencerByTwitterHandle(params)
      if (resp) commit('SET_DATA', { name: 'twitterInf', data: resp })
    } catch (err) {
      console.error(err)
    }
  },
  /**
   * get inf by ig handle
   * @param {*} commit
   * @returns
  */
  async getInfluencerBriefInfoByIds ({ commit }, payload) {
    try {
      let filters = {}
      if (payload) {
        filters = payload.filters
      }
      commit('SET_Infs', [])
      let resp = await influencerAPIs.getInfluencerByIds(filters)
      if (resp) {
        commit('SET_Infs', resp)
      }
    } catch (err) {
      console.error(err)
      return ''
    }
  },
  /**
   * get inf detail info
   * @param {String} id
   * @param {*} commit
   * @returns
  */
  async getInfluencerDetail ({ commit }, payload) {
    try {
      let id = payload.id || ''
      if (!payload) {
        return false
      }
      commit('SET_InfDetail', {})
      let resp = await influencerAPIs.getInfluencer(id)
      if (resp) {
        commit('SET_InfDetail', resp)
      }
    } catch (err) {
      console.error(err)
      return ''
    }
  },
  /**
   * save merging inf
   * @param {*} commit
   * @returns
  */
  async mergeInf ({ commit }, payload) {
    try {
      commit('SET_SavedInfMerge', false)
      await influencerAPIs.saveMergingInf(payload.formData)
      commit('SET_SavedInfMerge', true)
    } catch (err) {
      console.error(err)
      return ''
    }
  },
  /**
   * Get imported creators
   * @param {*} commit
   * @returns
  */
  async getImportedCreators ({ commit }, payload) {
    try {
      commit('SET_DATA', {
        name: 'importedCreators',
        data: []
      })
      let resp = await apiService.post(infServiceBaseURL + '/imported/creators', payload)
      commit('SET_DATA', {
        name: 'importedCreators',
        data: resp
      })
    } catch (err) {
      console.error(err)
      return ''
    }
  },
  /**
   * update imported creator by ids
   * @param {*} commit
   * @param {*} data
   * @returns
  */
  async updateImportedCreatorByIds ({commit}, payload) {
    try {
      commit('SET_DATA', {
        name: 'savedImportedCreator',
        data: false
      })
      await apiService.post(infServiceBaseURL + '/imported/creators/update-by/ids', payload)
      commit('SET_DATA', {
        name: 'savedImportedCreator',
        data: true
      })
    } catch (err) {
      console.error(err)
      return ''
    }
  },
  /**
   * Delete Audience Data
   * @param {*} commit
   * @returns
  */
  async deleteAud ({ commit }, payload) {
    try {
      commit('SET_DATA', {
        name: 'deletedAud',
        data: false
      })
      await apiService.post(infServiceBaseURL + '/delete/audience', payload)
      commit('SET_DATA', {
        name: 'deletedAud',
        data: true
      })
    } catch (err) {
      console.error(err)
      return ''
    }
  },
  /**
   * Delete Imported Creator
   * @param {*} commit
   * @returns
  */
  async deleteImportedCreator ({ commit }, payload) {
    try {
      commit('SET_DATA', {
        name: 'importedCreators',
        data: false
      })
      await apiService.post(infServiceBaseURL + '/imported/creators/delete', payload)
      commit('SET_DATA', {
        name: 'importedCreators',
        data: true
      })
    } catch (err) {
      console.error(err)
      return ''
    }
  },
  /**
   * Fetch from IQData for imported creator
   * @param {*} commit
   * @returns
  */
  async fetchIQDataImportedCreator ({ commit }, payload) {
    try {
      commit('SET_DATA', {
        name: 'importedCreatorDtl',
        data: null
      })
      let resp = await apiService.post(infServiceBaseURL + '/imported/creators/fetch/IQData', payload)
      if (resp) {
        if (!resp.id) {
          commit('SET_DATA', {
            name: 'socialDataErrMsg',
            data: resp.socialDataErr
          })
        } else {
          commit('SET_DATA', {
            name: 'importedCreatorDtl',
            data: resp
          })
        }
      }
    } catch (err) {
      console.error(err)
      return ''
    }
  },
  async getImportedCreatorGenres({ commit }, payload) {
    try {
      commit('SET_DATA', {
        name: 'importedCreatorGenres',
        data: []
      })
      let resp = await apiService.get(infServiceBaseURL + '/imported/creators/genres', payload)
      if (resp) {
        commit('SET_DATA', {
          name: 'importedCreatorGenres',
          data: resp
        })
      }
    } catch (err) {
      console.error(err)
      return ''
    }
  },
  async getImportedCreatorsCols({ commit }, payload) {
    try {
      commit('SET_DATA', {
        name: 'importedCreatorCols',
        data: []
      })
      let resp = await apiService.get(infServiceBaseURL + '/imported/creators/cols', payload)
      if (resp) {
        commit('SET_DATA', {
          name: 'importedCreatorCols',
          data: resp
        })
      }
    } catch (err) {
      console.error(err)
      return ''
    }
  },
  /**
   * get all tags
  */
  async getAllTags({ commit }) {
    try {
      commit('SET_DATA', {
        name: 'allTags',
        data: []
      })
      let resp = await apiService.get(infServiceBaseURL + '/custom-tags/find')
      if (resp) {
        commit('SET_DATA', {
          name: 'allTags',
          data: resp
        })
      }
    } catch (err) {
      console.error(err)
      return ''
    }
  },
  /**
   * get all assigned tags
  */
  async getAllAssignedTags({ commit }) {
    try {
      commit('SET_DATA', {
        name: 'allAssignedTags',
        data: []
      })
      let resp = await apiService.get(infServiceBaseURL + '/assigned-tags/all/find')
      if (resp) {
        commit('SET_DATA', {
          name: 'allAssignedTags',
          data: resp
        })
      }
    } catch (err) {
      console.error(err)
      return ''
    }
  },
  /**
   * get custom tags
  */
  async getCustomTags({ commit }, payload) {
    try {
      commit('SET_DATA', {
        name: 'customTag',
        data: []
      })
      let params = ''
      if (payload) {
        const { filters } = payload
        params = Object.keys(filters)
        .map(key => `${key}=${filters[key]}`)
        .join('&')
      }
      let resp = await apiService.get(infServiceBaseURL + '/custom-tags/findOne?' + params)
      if (resp) {
        commit('SET_DATA', {
          name: 'customTag',
          data: resp
        })
      }
    } catch (err) {
      console.error(err)
      return ''
    }
  },
  /**
   * Update tag
   * @param {*} commit
   * @returns
  */
  async updateTag ({ commit }, payload) {
    try {
      commit('SET_DATA', {
        name: 'updatedTag',
        data: false
      })
      await apiService.post(infServiceBaseURL + '/custom-tags/create', payload)
      commit('SET_DATA', {
        name: 'updatedTag',
        data: true
      })
    } catch (err) {
      console.error(err)
      return ''
    }
  },
  /**
   * Delete tag
   * @param {*} commit
   * @returns
  */
  async deleteTag ({ commit }, payload) {
    try {
      commit('SET_DATA', {
        name: 'updatedTag',
        data: false
      })
      await apiService.post(infServiceBaseURL + '/custom-tags/delete', payload)
      commit('SET_DATA', {
        name: 'updatedTag',
        data: true
      })
    } catch (err) {
      console.error(err)
      return ''
    }
  },
  /**
   * get all assigned tags for each creator
  */
  async getAssignedTags({ commit }, payload) {
    try {
      commit('SET_DATA', {
        name: 'assignedTags',
        data: []
      })
      let resp = await apiService.post(infServiceBaseURL + '/assigned-tags/find', payload)
      if (resp) {
        commit('SET_DATA', {
          name: 'assignedTags',
          data: resp
        })
      }
    } catch (err) {
      console.error(err)
      return ''
    }
  },
  /**
   * update ratecard by ids
   * @param {*} commit
   * @param {*} data
   * @returns
  */
  async updateRateCardByIds ({commit}, payload) {
    try {
      commit('SET_DATA', {
        name: 'savedRateCard',
        data: false
      })
      await apiService.post(infServiceBaseURL + '/rate-card/update-by/ids', payload)
      commit('SET_DATA', {
        name: 'savedRateCard',
        data: true
      })
    } catch (err) {
      console.error(err)
      return ''
    }
  },
  /**
   * update creator community by ids
   * @param {*} commit
   * @param {*} data
   * @returns
  */
  async updateCreatorCommunityByIds ({commit}, payload) {
    try {
      commit('SET_DATA', {
        name: 'savedCreatorCommunity',
        data: false
      })
      await apiService.post(infServiceBaseURL + '/creator-community/update-by/ids', payload)
      commit('SET_DATA', {
        name: 'savedCreatorCommunity',
        data: true
      })
    } catch (err) {
      console.error(err)
      return ''
    }
  }
}

const getters = {
}

/**
 * Need actions to implement
 */
// const actions = {}

const mutations = {
  SET_SAVE_RATECARD(state) {
    state.savedRateCard = true
  },
  UNSET_SAVE_RATECARD(state) {
    state.savedRateCard = false
  },
  SET_RATE_CARD(state, data) {
    state.rateCards = data
  },
  SET_SAVE_CREATORCOMMUNITY(state) {
    state.savedCreatorCommunity = true
  },
  UNSET_SAVE_CREATORCOMMUNITY(state) {
    state.savedCreatorCommunity = false
  },
  SET_CREATOR_COMMUNITY(state, data) {
    state.creatorCommunities = data
  },
  UnsetSavedPlatforms(state) {
    state.savedPlatforms = false
  },
  SetSavedPlatforms(state) {
    state.savedPlatforms = true
  },
  SET_SocialDataSuccess(state, status) {
    state.socialDataSuccess = status
  },
  SET_SocialDataExist(state, status) {
    state.socialDataExist = status
  },
  SET_SocialDataErrMsg(state, message) {
    state.socialDataErrMsg = message
  },
  SET_IgInf(state, data) {
    state.igInf = data
  },
  SET_TikTokInf(state, data) {
    state.tiktokInf = data
  },
  SET_YoutubeInf(state, data) {
    state.youtubeInf = data
  },
  SET_Infs(state, data) {
    state.influencers = data
  },
  SET_InfDetail(state, data) {
    state.infDetail = data
  },
  SET_SavedInfMerge(state, status) {
    state.savedInfMerge = status
  },
  SET_CompareInfEmpty(state) {
    state.igInf = {}
    state.tiktokInf = {}
    state.youtubeInf = {}
    state.xhsInf = {}
    state.fbInf = {}
    state.linkedinInf = {}
    state.twitterInf = {}
  },
  SET_DATA(state, { name, data }) {
    state[name] = data
  }
}

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/influencer.js